import { useContext } from "react";
import AppContext from "src/context/appContext";

const useApp = () => {
  const value = useContext(AppContext);
  return value;
};

export default useApp;
